import classNames from 'classnames';
import { useRef, useEffect, useState } from 'react';
import { usePopper } from 'react-popper';

export interface DotIndicatorProps {
  numDots: number;
  selectedDot: number;
  setSelectedDot: (index: number) => void;
}

export const DotIndicator = ({
  numDots,
  selectedDot,
  setSelectedDot,
}: DotIndicatorProps) => {
  const dotRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (dotRefs.current[selectedDot]) {
        setReferenceElement(dotRefs.current[selectedDot]);
        clearInterval(interval);
        setTimeout(() => {
          setReady(true);
        }, 200);
      }
    }, 200);
    return () => clearInterval(interval);
  }, [selectedDot, numDots]);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [-8, -11],
        },
      },
    ],
  });

  return (
    <div className="flex space-x-2 items-center relative">
      {Array.from({ length: numDots }, (_, index) => (
        <div
          key={index}
          ref={(el) => {
            dotRefs.current[index] = el;
          }}
          className={classNames(
            'cursor-pointer rounded-full bg-gray-600 transition-width transition-height duration-300 w-2 h-2'
          )}
          onClick={() => setSelectedDot(index)}
        />
      ))}
      {/* The moving circle */}
      {referenceElement && (
        <div
          ref={setPopperElement}
          style={{
            ...styles.popper,
            pointerEvents: 'none',
            opacity: ready ? 1 : 0,
            zIndex: 10,
          }}
          {...attributes.popper}
          className="absolute transition-transform duration-300"
        >
          <div className="rounded-full border-2 border-gray-600 w-3.5 h-3.5" />
        </div>
      )}
    </div>
  );
};

export default DotIndicator;
